<template>
    <div class="video-wrapper">
        <iframe width="853" height="480"  class="video" :src="embed"   frameborder="0"  allowfullscreen >
        </iframe>
    </div>
</template>
<script>
export default {
    props:{
        embed:{type:String}
    }
    
}
</script>
<style scoped>
    .video-wrapper {
        position: relative;
        padding-bottom: 56.25%;
        height: 32vw;
        overflow: hidden;
        /*margin-top: 10px;*/
        /*margin-left: 10px;*/
    }

    .video-wrapper object,
    .video-wrapper embed,
    .video-wrapper iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// node_modules/modal-export/src/components/IframeComponent.vue